import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TreoNavigationItem } from 'tsui/@treo';
import { AuthService } from 'app/core';

@Component({
  selector: 'profile-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileSidebarComponent implements OnInit {
  menuData: TreoNavigationItem[] = [];

  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    this.menuData = [
      {
        title: 'User Settings',
        type: 'group',
        children: [
          {
            title: 'Profile',
            type: 'basic',
            icon: 'settings',
            link: './general',
          },
          {
            title: 'Notifications',
            type: 'basic',
            icon: 'notifications',
            link: './notifications',
          },
        ],
      },
    ];
  }
}
